// extracted by mini-css-extract-plugin
export default {"eventsNav":"EventsNavigation_eventsNav__sIMji","btn":"EventsNavigation_btn__vqoFP","active":"EventsNavigation_active__lV25V"};